<template>
  <div class="modal-backdrop fade show blockscreen">
    <span class="spinner-border spinner-border-xl" />
  </div>
</template>
